import { useEffect } from 'react';
import Client from 'App/client';
import Questionnaire from 'scenes/Questionnaire';

const QRTask = (props) => {
  useEffect(() => {
    setHeaders();
  }, []);

  const setHeaders = () => {
    const signatureFromStorage = window.sessionStorage.getItem('@keethealth/signature');

    Client.setHeaders({
      Authorization: `Basic ${signatureFromStorage}`,
    });
  };

  return <Questionnaire {...props} getNextActivity={() => {}} />;
};

export default QRTask;
